import http from 'utils/http';
import {
  getBusinessNotificationMarkReadUrl,
  getBusinessNotificationsMarkAllReadUrl,
  getBusinessNotificationsUnreadCountUrl,
  getBusinessNotificationsUrl
} from './apiUrls';
import { NotificationsListResponse, UnreadCountResponse } from './types';

export function getBusinessNotifications(params?: {
  page?: number;
  per_page?: number;
  unread_only?: boolean;
}): Promise<NotificationsListResponse> {
  return http.get(getBusinessNotificationsUrl(), params);
}

export function getBusinessNotificationsUnreadCount(): Promise<UnreadCountResponse> {
  return http.get(getBusinessNotificationsUnreadCountUrl());
}

export function markBusinessNotificationRead(id: number): Promise<unknown> {
  return http.patch(getBusinessNotificationMarkReadUrl(id));
}

export function markAllBusinessNotificationsRead(): Promise<unknown> {
  return http.post(getBusinessNotificationsMarkAllReadUrl());
}
